import React, { useState } from "react";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import * as HTTPServices from "../../../../api/HTTPServices";
import ModalComponent from "../../../ModalComponent";
import "react-html5-camera-photo/build/css/index.css";
import ImagePreview from "./imagePreview";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useTranslation } from "react-i18next";

function Index({
  handleOpenCamera,
  handleCloseCamera,
  audienceId,
  visitToken,
  addMessageToList,
  attachType,
}) {
  const { t } = useTranslation();
  const isFullscreen = false;
  const [dataUri, setDataUri] = useState("");
  const [confirm, setConfirm] = useState(false);
  //   const [facingMode, setFacingMode] = useState("FACING_MODES.ENVIRONMENT");

  function handleTakePhotoAnimationDone(dataUri) {
    setDataUri(dataUri);
    setTimeout(() => {
      setConfirm(true);
    }, 2000);
  }

  function submitShot() {
    function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    }
    var convertedFile = dataURLtoFile(dataUri, `${Math.random(10)}.jpg`);

    let formData = new FormData();
    formData.append("message", "");
    formData.append("audience", audienceId);
    formData.append("room_token", visitToken);
    if (attachType === "prescription") {
      formData.append("type", "prescriptionPhoto");
    } else {
      formData.append("type", "dossierPhoto");
    }
    formData.append(`file`, convertedFile);

    const RequestService = HTTPServices.postMethod("chat", formData, "true");
    RequestService.then(function (response) {
      if (response) {
        setDataUri("");
        setConfirm(false);
        addMessageToList(response.message);
        handleCloseCamera();
      }
    }).catch(function (error) {});
  }

  return (
    <ModalComponent
      open={handleOpenCamera}
      handleClose={() => {
        handleCloseCamera();
        setDataUri("");
      }}
      closeBtn={true}
      confirmBtn={false}
      //   handleOk={uploadPhoto}
      title={t("components.AppointmentRoom.RoomFooter.CameraModal.title")}
    >
      {dataUri ? (
        <ImagePreview dataUri={dataUri} isFullscreen={isFullscreen} />
      ) : (
        <Camera
          onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
          onCameraError={() => {
            alert("no camera found or there is an error on your camera");
            setDataUri("");
            setConfirm(false);
          }}
          isFullscreen={isFullscreen}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          isImageMirror={false}
        />
      )}

      {confirm && (
        <div>
          <Dialog
            open={true}
            onClose={() => {
              setConfirm(false);
            }}
            aria-labelledby="form-dialog-title"
          >
            <DialogContent>
              <DialogContentText className="dialog_text">
                {t(
                  "components.AppointmentRoom.RoomFooter.CameraModal.askAboutPhoto"
                )}
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => {
                  setDataUri("");
                  setConfirm(false);
                }}
                color="primary"
                className="button_dialog"
              >
                {t(
                  "components.AppointmentRoom.RoomFooter.CameraModal.takePhotoAgaing"
                )}
              </Button>
              <Button
                onClick={submitShot}
                color="primary"
                className="button_dialog"
              >
                {t("components.AppointmentRoom.RoomFooter.CameraModal.itsOk")}
              </Button>
              <Button
                onClick={() => {
                  setDataUri("");
                  setConfirm(false);
                }}
                color="primary"
                className="button_dialog"
              >
                {t("components.AppointmentRoom.RoomFooter.CameraModal.cancel")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </ModalComponent>
  );
}

export default Index;
